import { Helper } from '../Helper';
export class ExtendArrHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'LT');
            },
            each: () => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'DUP');
                sb.emitHelper(node, options, sb.helpers.wrapUndefined);
                sb.emitOp(node, 'APPEND');
            },
            incrementor: () => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'SWAP');
            },
            cleanup: () => {
            },
        }));
        sb.emitOp(node, 'DROP');
        sb.emitOp(node, 'DROP');
        sb.emitOp(node, 'DROP');
    }
}

//# sourceMappingURL=ExtendArrHelper.js.map
